// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2kNpg","productName":"Table_productName__2xz-S"};